/* eslint-disable react-native/no-inline-styles */
/*
Author: Lukman Yudokusumo
*/

import React from 'react';
import { View, KeyboardAvoidingView } from 'react-native';
import * as Yup from 'yup';

import { buttonFloating, buttonRounded } from '@/assets/styles/buttonStyles';
import {
  SociollaInput,
  SociollaForm,
  SociollaSubmitButton,
} from '@components/sociolla/form';
import SociollaText from '@components/sociolla/SociollaText';
import ModalHalf from '@components/modal/ModalHalf';

import Colors from '@global/colors';
import { isWeb, isIos } from '@global/screens';
import PropTypes from 'prop-types';

const propTypes = {
  onSubmit: PropTypes.func,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  testID: PropTypes.string,
};

const ModalCancel = (props) => {
  const buttonWidth = isWeb ? 300 : '100%';
  const handleSubmit = (data) => props.onSubmit(data.reason);

  return (
    <KeyboardAvoidingView behavior={isIos ? 'padding' : undefined}>
      <ModalHalf
        testID={props.testID}
        visible={props.show}
        fullPage={isWeb ? true : false}
        animationType={isWeb ? 'fade' : 'slide'}
        maxWidth={isWeb ? 450 : '100%'}
        onClose={props.onClose}
        title={props.title ? props.title : 'Cancel Sales Order'}>
        <SociollaForm
          initialValues={{ reason: '' }}
          onSubmit={handleSubmit}
          validationSchema={Yup.object().shape({
            reason: Yup.string().required('Reason is required').label('Reason'),
          })}>
          <View style={{ width: '100%', paddingHorizontal: 16 }}>
            <SociollaText
              style={{
                fontSize: 11,
                marginBottom: 8,
                color: Colors.grey2,
              }}>
              {props.description || 'This Sales Order Will be Cancelled.'}
            </SociollaText>
            <SociollaInput
              label="Enter reason for cancel :"
              multiline={true}
              numberOfLines={4}
              name="reason"
            />
            <View
              style={[
                isWeb
                  ? { alignItems: 'center', marginTop: 24 }
                  : {
                      ...buttonFloating,
                      marginTop: 20,
                      padding: 0,
                      paddingTop: 15,
                      justifyContent: 'center',
                      position: 'relative',
                      elevation: 0,
                    },
                { width: '100%', bottom: 0 },
              ]}>
              <SociollaSubmitButton
                buttonStyle={{
                  ...buttonRounded,
                  width: buttonWidth,
                  ...(isWeb ? { marginHorizontal: 10 } : {}),
                }}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.white,
                      width: '100%',
                      textAlign: 'center',
                    }}>
                    Submit
                  </SociollaText>
                }
              />
            </View>
          </View>
        </SociollaForm>
      </ModalHalf>
    </KeyboardAvoidingView>
  );
};

ModalCancel.propTypes = propTypes;

export default ModalCancel;
